export default "__VITE_ASSET__Dl2558Rs__"